/** Copy of the web revocation confirmation (kept in one place so the UI and its test cannot drift). */
export const revokeConfirmation = (machineName: string) => ({
  title: `Revoke ${machineName}?`,
  message:
    "This Machine will no longer be able to connect to your racler.dev account. You can pair it again later from the racler.dev app.",
  consequence: "This Machine will immediately lose access to your account.",
  confirmLabel: "Revoke",
});
